module.exports = __webpack_public_path__ + "static/img/icon_h5.2743713d.png";